export default "__VITE_ASSET__XwdSCMxz__"